import { render, staticRenderFns } from "./ContractDialog.vue?vue&type=template&id=27d5e9d6&scoped=true&"
import script from "./ContractDialog.vue?vue&type=script&lang=js&"
export * from "./ContractDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContractDialog.vue?vue&type=style&index=0&id=27d5e9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5e9d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
